import Vue from "vue";
import { API } from "aws-amplify";
import { debounce } from "lodash";
import { bodyWithAuthHeader, handleHttpError } from "../utils/utils";

const locService = Vue.prototype.$localizationService;

const API_PATH = "/inventory";

export default {
  name: "inventoryModule",
  namespaced: true,
  state: {
    currentPageLoading: false,
    currentPage: {
      inventory: [],
      index: 0,
      size: 25,
      sort: [],
      searchString: "",
    },
    displayInventory: [],
    totalCount: 0,
  },
  mutations: {
    startLoadingPage(state, currentPage) {
      state.currentPageLoading = true;
      state.currentPage = currentPage;
    },

    endLoadingPage(state) {
      state.currentPageLoading = false;
    },

    updateCurrentPageInventory(state, inventoryDto) {
      state.currentPage.inventory = [...inventoryDto];
      state.displayInventory = state.currentPage.inventory;
    },

    updateTotalCount(state, newValue) {
      state.totalCount = newValue;
    },
  },
  actions: {
    reloadPage: debounce(async ({ dispatch, state }) => {
      dispatch("loadPage", state.currentPage);
    }, 300),

    async loadPage({ commit }, currentPage) {
      commit("startLoadingPage", currentPage);

      try {
        const queryParams = {
          page: currentPage.index,
          size: currentPage.size,
        };

        if (currentPage.sort && currentPage.sort.length > 0) {
          queryParams.sort = currentPage.sort.join(",");
        }

        const body = {
          ...(await bodyWithAuthHeader()),
          queryStringParameters: queryParams,
        };

        let response;
        if (currentPage.searchString && currentPage.searchString.trim()) {
          body.queryStringParameters.itemName = currentPage.searchString;
          response = await API.get("core", `${API_PATH}/search`, body);
        } else {
          response = await API.get("core", API_PATH, body);
        }

        commit("updateCurrentPageInventory", response.items);
        commit("updateTotalCount", response.total);
      } catch (e) {
        handleHttpError(e);
      }
      commit("endLoadingPage");
    },

    async deleteInventory({ commit, dispatch, state }, inventory) {
      const body = await bodyWithAuthHeader();

      try {
        await API.del("core", `${API_PATH}/${inventory.id}`, body);
        commit("updateTotalCount", state.totalCount - 1);
        dispatch("reloadPage");
        return locService.localize("store.inventory.delete_inventory_msg", [
          inventory.itemName,
        ]);
      } catch (e) {
        throw e.response?.data?.message || e.message;
      }
    },

    async addOrSaveInventory({ commit, dispatch, state }, inventory) {
      const body = {
        ...(await bodyWithAuthHeader()),
        body: {
          itemName: inventory.itemName,
          size: inventory.size || null,
          totalQty: inventory.totalQty,
        },
      };

      try {
        const result = await (inventory.id
          ? API.put("core", `${API_PATH}/${inventory.id}`, body)
          : API.post("core", API_PATH, body));

        if (!inventory.id) {
          commit("updateTotalCount", state.totalCount + 1);
        }

        dispatch("reloadPage");
        return locService.localize(
          inventory.id
            ? "store.inventory.save_inventory_msg"
            : "store.inventory.add_inventory_msg",
          [result.itemName],
        );
      } catch (e) {
        throw e.response?.data?.message || e.message;
      }
    },
  },
};
